module.exports = __webpack_public_path__ + "images/emoji/eight.82312d96c6da7428cd1e.png";